// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"332":"c1665022","583":"5f99c0b8","643":"fcd30e9e","651":"22863e82","666":"36f17416","840":"30aa177d"}[chunkId] + ".chunk.css";
};